import { render, staticRenderFns } from "./ClassificationListView.vue?vue&type=template&id=463b0754&scoped=true"
import script from "./ClassificationListView.vue?vue&type=script&lang=js"
export * from "./ClassificationListView.vue?vue&type=script&lang=js"
import style0 from "./ClassificationListView.vue?vue&type=style&index=0&id=463b0754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b0754",
  null
  
)

export default component.exports